import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=4a1c5829&scoped=true&"
import script from "./UpgradeCard.vue?vue&type=script&lang=js&"
export * from "./UpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeCard.vue?vue&type=style&index=0&id=4a1c5829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c5829",
  null
  
)

export default component.exports